import React, { useState, useEffect } from 'react';
import HeaderContent from "components/Header/Content";
import NavBar from 'components/Header/NavBar';
import AppDownload from './AppDownload';
import {addClass} from 'utils';
import CMSService from 'services/CMS/';
import style from './style.scss';//NOSONAR

let firstPosition = 0;

const NewHeader = () => {

    const [categories, setCategories] = useState([]);
    const [sticky, setSticky] = useState(false);
    const [fixedCategories, setFixedCategories] = useState([]);

    useEffect(() => {
        if(window){
            window.addEventListener('scroll', scrolling);
        }

        CMSService.getMenu().then(results => {
            if(!results) return false;
            
            const {items} = results.acf;
            const fixedCats = results.acf.fixed_categories;

            setCategories(items);
            setFixedCategories(fixedCats);
        });

        addClass(document.body, 'new-home');

        return function cleanup(){
            window.removeEventListener('scroll', scrolling);
        }
    }, []);

    const scrolling = () =>{
        const sY = window.scrollY;

        if(firstPosition < 0) {
            firstPosition = 0;
        }

        if(sY > firstPosition){
            setSticky(true);
        }else{
            setSticky(false);
        }

        firstPosition = sY;
    }


    return <header className={'new-header'+(sticky ? ' sticky': '')}>
        <AppDownload />
        <HeaderContent categories={categories} fixedCategories={fixedCategories}/>
        <NavBar categories={categories} fixedCategories={fixedCategories}/>
    </header>;
};

export default NewHeader;
